<template>
  <div>

    <div v-show="showPopup.remove" class="sweet-alert showSweetAlert visible" data-allow-outside-click="false" data-animation="pop" style="border:1px dashed gray;display: block;">
      <div class="sa-icon sa-info" style="display: block;"></div>
      <h2>Confirmation</h2>
      <p class="lead text-muted text-left" v-if="quizToRemove">
        Etes-vous sûr de vouloir supprimer le questionnaire « {{quizToRemove.title}} » ?
      </p>
      <div class="sa-button-container">
        <button class="cancel btn btn-lg btn-default btn-danger" v-on:click="showPopup.remove=false">Annuler</button>
        <div class="sa-confirm-button-container">
          <button class="confirm btn btn-lg btn-success" v-on:click="removeQuiz()">Oui</button>
        </div>
      </div>
    </div>

    <div v-show="showPopup.duplicate" class="sweet-alert showSweetAlert visible" data-allow-outside-click="false" data-animation="pop" style="border:1px dashed gray;display: block;">
      <div class="sa-icon sa-info" style="display: block;"></div>
      <h2>Formulaire de duplication</h2>
      <p class="lead text-muted text-left" v-if="quizToDuplicate">
        Vous êtes sur le point de dupliquer le questionnaire « {{quizToDuplicate.title}} ».<br><br>
        Veuillez choisir le titre de la copie de ce questionnaire, <span class="text-danger">attention le titre ne pourra pas être changé après la duplication</span>.
      </p>
      <div class="col-xs-12">
        <div class="form-group form-md-line-input" style="display:block;">
          <form id="formDuplicate" class="absolute-parlsey-errors">
            <input type="text" class="form-control" v-model="newTitle" placeholder="Nouveau titre" required>
            <div class="form-control-focus"> </div>
          </form>
        </div>
      </div>
      <div class="sa-button-container">
        <button class="cancel btn btn-lg btn-default btn-danger" v-on:click="showPopup.duplicate=false">Annuler</button>
        <div class="sa-confirm-button-container">
          <button class="confirm btn btn-lg btn-success" v-on:click="duplicateQuiz()">Valider</button>
        </div>
      </div>
    </div>

    <section class="tile">
        <div class="tile-header dvd dvd-btm tabbable-line">
            <h1>Liste des questionnaires</h1><br>
            <br><br>
        </div>
        <div class="tile-body mb-50">
            <list :columns="columns" :dataSet="dataSet" :order="[ 1, 'asc' ]"></list>
            <router-link :to="{name:'quizzes_create'}" class="btn btn-circle green mt-20">
              <i class="fa fa-plus"></i>
               Nouveau questionnaire
            </router-link>
        </div>
    </section>
  </div>
</template>

<script>

import quizzes from '../../requests/quizzes.js'
import storage from '../../storage/data.js'
import List from '../others/list.vue'

export default {
  name: 'quizzes_list',
  components: {
    List
  },
  data () {
    return{
      dataSet:[],
      columns:[],
      showPopup:{
        remove:false,
        duplicate:false
      },
      quizToRemove:null,
      quizToDuplicate:null,
      newTitle:""
    }
  },
  mounted:function(){
    this.getData();
  },
  methods:{
    showData(quizzes,error){
      var parent = this;
      if (!error) {
          parent.dataSet = [];
          // console.log("show data",quizzes.length);
          for(var a=0;a<quizzes.length;a++){
              var tr = [];
              tr.push(quizzes[a].title);
              tr.push(quizzes[a].date_created ? new Date(quizzes[a].date_created).toLocaleDateString() : "");
              tr.push(quizzes[a].date_deadline ? new Date(quizzes[a].date_deadline).toLocaleDateString() : "");
              tr.push(quizzes[a].groups.length);
              tr.push(quizzes[a].company ? quizzes[a].company.name : "");
              var state = "";
              switch(quizzes[a].state){
                case "draft":
                  state = '<span class="label label-sm label-warning"> Brouillon </span>';
                break;
                case "published":
                  state = '<span class="label label-sm label-success"> Publié </span>';
                break;
              }
              tr.push(state);
              var actions = quizzes[a].state == "published" ? '<a data-route-name="quizzes_responses" data-slug="'+quizzes[a].slug+'" class="btn btn-default text-right btn-circle btn_table btn_perso"><i class="icon-eye"></i></a>' : "";
              actions += quizzes[a].state == 'draft' ? '<a data-route-name="quizzes_edit" data-slug="'+quizzes[a].slug+'" class="btn btn-default btn-circle text-right ml-5 btn_table btn_perso"><i class="icon-note"></i></a>' : "";
              actions += quizzes[a].state == 'published' ? '<a data-route-name="quizzes_edit" data-slug="'+quizzes[a].slug+'" class="btn btn-default btn-circle text-right ml-5 btn_table btn_perso"><i class="icon-share"></i></a>' : "";
              actions += '<a class="btn btn-default text-right ml-5 btn_table btn-circle btn_duplicate" data-index="'+a+'"><i class="icon-docs"></i></a>';
              actions += '<a class="btn btn-default text-right ml-5 btn_table btn-circle btn_remove" data-index="'+a+'"><i class="icon-trash"></i></a>';
              tr.push(actions)

              parent.dataSet.push(tr);
          }

          $(document).off('click','.btn_perso');
          $(document).on('click', '.btn_perso', function () {
              parent.$router.push({name:this.getAttribute("data-route-name"),params:{slug:this.getAttribute("data-slug")}})
          });

          $(document).off('click','.btn_remove');
          $(document).on('click', '.btn_remove', function () {
              parent.showPopup.remove = true;
              parent.quizToRemove = quizzes[this.getAttribute("data-index")];
          });

          $(document).off('click','.btn_duplicate');
          $(document).on('click', '.btn_duplicate', function () {
              parent.showPopup.duplicate = true;
              parent.quizToDuplicate = quizzes[this.getAttribute("data-index")];
          });


          parent.columns = [];
          parent.columns.push({title:"Titre"});
          parent.columns.push({title:"Date de création"});
          parent.columns.push({title:"Date limite"});
          parent.columns.push({title:"Nombre de groupe"});
          parent.columns.push({title:"Entreprise"});
          parent.columns.push({title:"Etat"});
          parent.columns.push({title:"Actions","searchable": false,"orderable": false,class:"text-right"});
      } else {
          toastr.error("ERREUR dans la récupération des questionnaires.");
      }
    },
    getData(){
      var parent = this;

      if(storage.data.user.role == "dev"){
        quizzes.getAll(this,function(quizzes,error){
          parent.showData(quizzes,error);
        });
      }
      else{
        quizzes.getAllMyQuizzes(this,function(quizzes,error){
          parent.showData(quizzes,error);
        });
      }
    },
    removeQuiz(){
      var parent = this;
      quizzes.removeBySlug(this,this.quizToRemove.slug,function(count,err){
        if(err){
          toastr.error(err,"ERREUR");
        }
        else{
          toastr.success("Le questionnaire "+parent.quizToRemove.title+" a été supprimé.");
        }
        parent.getData();
        parent.showPopup.remove = false;
        parent.quizToRemove = null;
      })
    },
    duplicateQuiz(){
      $("#formDuplicate").parsley().validate();
      if($("#formDuplicate").parsley().isValid()){
        var parent = this;
        quizzes.duplicateBySlug(this,this.quizToDuplicate.slug,this.newTitle,function(count,err){
          if(err){
            toastr.error(err,"ERREUR");
          }
          else{
            toastr.success("Le questionnaire "+parent.quizToDuplicate.title+" a été dupliqué en "+parent.newTitle);
            parent.newTitle = "";
            parent.getData();
            parent.showPopup.duplicate = false;
            parent.quizToDuplicate = null;
          }
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// list.vue?efe86dca